import { cn } from '@/lib/cn'

type Tone = 'light' | 'dark'

/** `light` sits on ink backgrounds (sidebar, hero); `dark` sits on bone backgrounds. Same mark as brand/logos. */
export function LogoMark({ className, tone = 'light' }: { className?: string; tone?: Tone }) {
  const tile = tone === 'light' ? '#F7F5EF' : '#0B0C0A'
  const glyph = tone === 'light' ? '#0B0C0A' : '#F7F5EF'
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn('size-8 shrink-0', className)}>
      <rect width="32" height="32" rx="8" fill={tile} />
      <path
        d="M9 22.5 15.2 9h1.6L23 22.5h-3.1l-1.2-2.8h-5.4l-1.2 2.8H9Zm5.1-5.3h3.8L16 12.6l-1.9 4.6Z"
        fill={glyph}
      />
      <circle cx="23.5" cy="9.5" r="2.5" fill="#C8F169" />
    </svg>
  )
}

/**
 * The Arva SEO logo from the brand files (public/brand, copied from
 * brand/logos/svg): `light` is the version for ink backgrounds, `dark` for
 * bone ones, switching to the ink-background version in dark mode.
 */
export function Logo({ className, tone = 'light' }: { className?: string; tone?: Tone }) {
  const size = 'h-8 w-auto'
  return tone === 'light' ? (
    <img
      src="/brand/arvaseo-logo-on-dark.svg?v=20261012"
      alt="Arva SEO"
      width={126}
      height={32}
      className={cn(size, className)}
    />
  ) : (
    <span className={cn('inline-flex', className)}>
      <img
        src="/brand/arvaseo-logo-on-light.svg?v=20261012"
        alt="Arva SEO"
        width={126}
        height={32}
        className={cn(size, 'dark:hidden')}
      />
      <img
        src="/brand/arvaseo-logo-on-dark.svg?v=20261012"
        alt="Arva SEO"
        width={126}
        height={32}
        className={cn(size, 'hidden dark:block')}
      />
    </span>
  )
}
